/**
 * Extended ViewController template
 *
 * User: adic
 * Date: 8/13/13
 * Time: 11:38 AM
 */

define(function (require) {

    window.lpTag = window.lpTag || {};

    var App = window.App || {};
    var agentStatus = "";
    // var MainViewController = require('web-agent-viewControllers/MainViewController');

    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');


    var LEMenuItemsViewController = ViewController.extend({
        ControllerName: 'LEMenuItemsViewController',
        ICON_STATUS_PREFIX: "webagent_status_widget icon ",

        LPViewMap: {
        },

        initialize: function () {
            var that = this;
            this.chatAvailabilityTrayItem = createTrayItem(this, this.translate("online"), this.ICON_STATUS_PREFIX);
            this.statusMenuItems = {};
            this.statusMenuItems.Away = createMenuItemForStatus(this, this.translate("away"), "Away", "away", 0);
            this.statusMenuItems.Occupied = createMenuItemForStatus(this, this.translate("backIn5"), "Occupied", "brb", 1);
            this.statusMenuItems.Online = createMenuItemForStatus(this, this.translate("online"), "Online", "online", 2);

        function createTrayItem(context, title, iconClass) {
            var TrayMenuItemModel = agentLEManager.getLEUserBarModel("TrayMenuItemModel");
            var statusTrayIcon = new TrayMenuItemModel({
                type: TrayMenuItemModel.TYPES.AVAILABILITY,tooltip: title,
                context: context,
                iconClass: iconClass,
                index: 1
            });

                agentLEManager.addLEUserBarTrayItem(statusTrayIcon);
                return statusTrayIcon;
            }

            function createMenuItemForStatus(context, title, availability, className, index) {
                var menuStatusItemModel = createMenuStatusItem(context, title, availability, that.ICON_STATUS_PREFIX + className, createSetAvailabilityFunc(context.modelController, availability), index);
                return menuStatusItemModel;
            }

            function createMenuStatusItem(context, title, availability, className, callback, index) {
                var TopLevelMenuStatusItemModel = agentLEManager.getLEUserBarModel("TopLevelMenuStatusItemModel");
                var menuStatusItemModel = new TopLevelMenuStatusItemModel({
                    title: title,
                    availabilityTitle: title,
                    callback: callback,
                    iconClass: className,
                    context: context,
                    value: availability,
                    selected: false
                });

                agentLEManager.addLEUserBarStatusItem(menuStatusItemModel, index);
                return menuStatusItemModel;
            }

            function createSetAvailabilityFunc(modelController, availability) {
                return function (reasonId) {
                    modelController.setAvailability({
                        chatAvailability: availability,
                        chatReasonId: reasonId
                    });
                };
            }
        },

        events: function () {
            this.bindModel({modelPath: "agent.chatReasonId", callback: this.chatAvailabilityReasonChanged});
            this.bindModel({modelPath: "agent.chatAvailability", callback: this.chatAvailabilityChanged});
            this.bindModel({modelPath: "agent.isSoundEnable", callback: this.chatAvailabilityChanged});
            this.registerShortcut(this.shortcutType.STATUS_WIDGET, this.toggleStatus);
            this.bindModel({modelPath : "agent.connectionState", callback : this.handleConnectionState});
            this.bindModel({modelPath : "agent.status", callback : this.handleAgentStatusChanged});
            //this.bindModel({modelPath : "agent.isChatAvailabilityByServer", callback : this.changeToAwayPopup});
        },

        render: function () {
        }
    });

    LEMenuItemsViewController.prototype.toggleStatus = function () {
        var availability = this.modelController.getModelParam("agent.chatAvailability");

        switch (availability) {
            case "Online" : this.modelController.setAvailability({chatAvailability : "Occupied"}); break;
            case "Occupied" : this.modelController.setAvailability({chatAvailability : "Away"}); break;
            case "Away" : this.modelController.setAvailability({chatAvailability : "Online"}); break;
        }
    };

    LEMenuItemsViewController.prototype.chatAvailabilityReasonChanged = function(data) {
        this.chatAvailabilityChanged({newValue: this.modelController.getModelParam("agent.chatAvailability")});
    };

    LEMenuItemsViewController.prototype.chatAvailabilityChanged = function(data) {
        if (!data.newValue) {
            return;
        }
        var tooltip;
        var iconClass = this.ICON_STATUS_PREFIX;

        switch (data.newValue) {
            case "Online" : tooltip = this.translate("online"); iconClass += "online"; break;
            case "Occupied" : tooltip = this.translate("backIn5"); iconClass += "brb"; break;
            case "Away" : tooltip = this.translate("away"); iconClass += "away"; break;
        }

        // Set tray item
        this.chatAvailabilityTrayItem.set("tooltip", tooltip);
        this.chatAvailabilityTrayItem.set("iconClass", iconClass);

        // Set menu item
        var currentStatusMenuItem = this.statusMenuItems[data.newValue];
        var reasonId = getReasonId(this);
        if(currentStatusMenuItem) {
            agentLEManager.setLEUserBarCurrentStatusItem(currentStatusMenuItem, reasonId);
        }

        function getReasonId(context) {
            var reasonId = context.modelController.getModelParam("agent.chatReasonId");
            if(reasonId === -1) {
                reasonId = null;
            }
            var retVal = parseInt(reasonId, 10);
            return !isNaN(retVal) ? retVal : null;
        }
    };

    LEMenuItemsViewController.prototype.handleConnectionState = function (data) {
        if (data.newValue) {
            if (agentStatus === "loggedOff" || data.newValue === "disabled") {
                this.setMenuItemsEnabled(false);
            } else {
                this.setMenuItemsEnabled(true);
            }
        }
    };

    LEMenuItemsViewController.prototype.handleAgentStatusChanged = function (data) {
        if (data.newValue) {
            agentStatus = data.newValue;
            if (data.newValue === "loggedOff") {
                this.setMenuItemsEnabled(false);
            } else {
                this.setMenuItemsEnabled(true);
            }
        }
    };

    LEMenuItemsViewController.prototype.changeToAwayPopup = function (data) {
        if (!data.newValue) {
            return;
        }
        if (data.newValue === true) {
            this.showDialog({
                title: this.translate("StatusChange"),
                description: this.translate("StatusChangeText"),
                okButton: this.translate("ok"),
                targetView: window.MainViewControllerBody,
                modal: true,
                xEnabled: true
            });
        }
    };

    LEMenuItemsViewController.prototype.setMenuItemsEnabled = function(isEnabled){
        // TODO: handle this case by removing or re-adding status menu items in case of connection issues
    };

    return LEMenuItemsViewController;

});
